module.exports = __webpack_public_path__ + "img/logo.983f56f6.png";